module.exports = __webpack_public_path__ + "img/jobseek.232aeb88.svg";